/** @jsxImportSource @emotion/react */
import { useMemo } from 'react';
import { Datepicker, Props as DatepickerProps } from '../Datepicker';
import { UtilityButton } from '../UtilityButton';

export type Props = DatepickerProps & {
  placeholder: string;
  variant?: 'primary' | 'secondary' | 'tertiary';
};

const getDisplayDate = (date: Date) => date.toLocaleDateString();

export const DateInput = ({
  placeholder,
  variant = 'tertiary',
  ...datepickerProps
}: Props) => {
  const { type, value } = datepickerProps;

  const buttonText = useMemo(() => {
    if (type === 'default') {
      if (value) return getDisplayDate(value as Date);
    }
    if (type === 'range') {
      const dates = value as Date[];
      const startDate = dates[0];
      const endDate = dates[1];
      if (startDate && !endDate) return `${getDisplayDate(startDate)} to Now`;
      if (startDate && endDate)
        return `${getDisplayDate(startDate)} to ${getDisplayDate(endDate)}`;
    }
    if (type === 'multiple') {
      const dates = value as Date[];
      if (dates.length > 0) return `Selected (${dates.length})`;
    }
    return placeholder;
  }, [placeholder, type, value]);

  return (
    <UtilityButton
      variant={variant}
      dropdown={({ close }) => (
        <Datepicker
          {...datepickerProps}
          onChange={(v: any) => {
            datepickerProps.onChange && datepickerProps.onChange(v);
            datepickerProps.type == 'default' && close();
          }}
        />
      )}
      text={buttonText}
    />
  );
};
